import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../urunDiv.css';
import buyukCay from '../../../../assets/menu/icecekler/sicak-icecekler/buyuk-cay.jpeg';
import filtreKahve from '../../../../assets/menu/icecekler/sicak-icecekler/filtre-kahve.jpeg';
import sutluFiltreKahve from '../../../../assets/menu/icecekler/sicak-icecekler/sutlu-filtre-kahve.jpeg';
import sicakCikolata from '../../../../assets/menu/icecekler/sicak-icecekler/sicak-cikolata.jpeg';
import kahveliSicakCikolata from '../../../../assets/menu/icecekler/sicak-icecekler/kahveli-sicak-cikolata.jpeg';
import sicakBeyazCikolata from '../../../../assets/menu/icecekler/sicak-icecekler/sicak-beyaz-cikolata.jpeg';
import salep from '../../../../assets/menu/icecekler/sicak-icecekler/salep.jpeg';
import salepliKahve from '../../../../assets/menu/icecekler/sicak-icecekler/salepli-kahve.jpeg';
import chaiTeaLatte from '../../../../assets/menu/icecekler/sicak-icecekler/chai-tea-latte.jpeg';
import matchaTeaLatte from '../../../../assets/menu/icecekler/sicak-icecekler/matcha-tea-latte.jpeg';
import detox from '../../../../assets/menu/icecekler/sicak-icecekler/detox.jpeg';
import berryHibiscus from '../../../../assets/menu/icecekler/sicak-icecekler/berry-hibiscus.jpeg';
import therapy from '../../../../assets/menu/icecekler/sicak-icecekler/therapy.jpeg';
import masala from '../../../../assets/menu/icecekler/sicak-icecekler/masala.jpeg';
import form from '../../../../assets/menu/icecekler/sicak-icecekler/form.jpeg';
import cool from '../../../../assets/menu/icecekler/sicak-icecekler/cool.jpeg';
import rooibosVanilla from '../../../../assets/menu/icecekler/sicak-icecekler/rooibos-vanilla.jpeg';
import whiteBlue from '../../../../assets/menu/icecekler/sicak-icecekler/white-blue.jpeg';
import papatya from '../../../../assets/menu/icecekler/sicak-icecekler/papatya.jpeg';
import melisa from '../../../../assets/menu/icecekler/sicak-icecekler/melisa.jpeg';
import ihlamur from '../../../../assets/menu/icecekler/sicak-icecekler/ihlamur.jpeg';
import elmaTarcinKarisik from '../../../../assets/menu/icecekler/sicak-icecekler/elma-tarcin-karisik.jpeg';

const SicakIcecekler = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const sicakIcecekKategorileri = {
    'Sıcak İçecekler': [
      {
        id: 1,
        name: 'Büyük Çay',
        price: '₺109,90',
        image: buyukCay
      },
      {
        id: 2,
        name: 'Filtre Kahve',
        price: '₺229,90',
        image: filtreKahve
      },
      {
        id: 3,
        name: 'Sütlü Filtre Kahve',
        price: '₺249,90',
        image: sutluFiltreKahve
      },
      {
        id: 4,
        name: 'Sıcak Çikolata',
        price: '₺229,90',
        image: sicakCikolata
      },
      {
        id: 5,
        name: 'Kahveli Sıcak Çikolata',
        price: '₺249,90',
        image: kahveliSicakCikolata
      },
      {
        id: 6,
        name: 'Sıcak Beyaz Çikolata',
        price: '₺229,90',
        image: sicakBeyazCikolata
      },
      {
        id: 7,
        name: 'Salep',
        price: '₺209,90',
        image: salep
      },
      {
        id: 8,
        name: 'Salepli Kahve',
        price: '₺229,90',
        image: salepliKahve
      },
      {
        id: 9,
        name: 'Chai Tea Latte',
        price: '₺209,90',
        image: chaiTeaLatte
      },
      {
        id: 10,
        name: 'Matcha Tea Latte',
        price: '₺249,90',
        image: matchaTeaLatte
      }
    ],
    'Bitki Çayları': [
      {
        id: 11,
        name: 'Detox',
        price: '₺239,90',
        image: detox
      },
      {
        id: 12,
        name: 'Berry Hibiscus',
        price: '₺239,90',
        image: berryHibiscus
      },
      {
        id: 13,
        name: 'Theraphy',
        price: '₺239,90',
        image: therapy
      },
      {
        id: 14,
        name: 'Masala',
        price: '₺239,90',
        image: masala
      },
      {
        id: 15,
        name: 'Form',
        price: '₺239,90',
        image: form
      },
      {
        id: 16,
        name: 'Cool',
        price: '₺239,90',
        image: cool
      },
      {
        id: 17,
        name: 'Rooibos Vanıllıa',
        price: '₺239,90',
        image: rooibosVanilla
      },
      {
        id: 18,
        name: 'White Blue',
        price: '₺239,90',
        image: whiteBlue
      },
      {
        id: 19,
        name: 'Papatya',
        price: '₺239,90',
        image: papatya
      },
      {
        id: 20,
        name: 'Melisa',
        price: '₺239,90',
        image: melisa
      },
      {
        id: 21,
        name: 'Ihlamur',
        price: '₺239,90',
        image: ihlamur
      },
      {
        id: 22,
        name: 'Elma Tarçın Karışık',
        price: '₺239,90',
        image: elmaTarcinKarisik
      }
    ]
  };

  const handleIcecekClick = (icecek) => {
    // Ürün sayfasına yönlendir
    const routeMap = {
      'Büyük Çay': '/sicak-icecekler/buyuk-cay',
      'Filtre Kahve': '/sicak-icecekler/filtre-kahve',
      'Sütlü Filtre Kahve': '/sicak-icecekler/sutlu-filtre-kahve',
      'Sıcak Çikolata': '/sicak-icecekler/sicak-cikolata',
      'Kahveli Sıcak Çikolata': '/sicak-icecekler/kahveli-sicak-cikolata',
      'Sıcak Beyaz Çikolata': '/sicak-icecekler/sicak-beyaz-cikolata',
      'Salep': '/sicak-icecekler/salep',
      'Salepli Kahve': '/sicak-icecekler/salepli-kahve',
      'Chai Tea Latte': '/sicak-icecekler/chai-tea-latte',
      'Matcha Tea Latte': '/sicak-icecekler/matcha-tea-latte',
      'Detox': '/sicak-icecekler/detox',
      'Berry Hibiscus': '/sicak-icecekler/sicak-berry-hibiscus',
      'Theraphy': '/sicak-icecekler/theraphy',
      'Masala': '/sicak-icecekler/masala',
      'Form': '/sicak-icecekler/form',
      'Cool': '/sicak-icecekler/cool',
      'Rooibos Vanıllıa': '/sicak-icecekler/rooibos-vanillia',
      'White Blue': '/sicak-icecekler/white-blue',
      'Papatya': '/sicak-icecekler/papatya',
      'Melisa': '/sicak-icecekler/melisa',
      'Ihlamur': '/sicak-icecekler/ihlamur',
      'Elma Tarçın Karışık': '/sicak-icecekler/elma-tarcin-karisik'
    };
    
    const route = routeMap[icecek.name];
    if (route) {
      navigate(route);
    }
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Sıcak İçecekler</h2>
        </div>
        
        {Object.entries(sicakIcecekKategorileri).map(([kategori, icecekler]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {icecekler.map((icecek) => (
                <div 
                  key={icecek.id} 
                  className="urun-kart"
                  onClick={() => handleIcecekClick(icecek)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{icecek.name}</h3>
                    <div className="urun-fiyat">{icecek.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={icecek.image} alt={icecek.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Sıcak İçecekler</h2>
        </div>
        
        {Object.entries(sicakIcecekKategorileri).map(([kategori, icecekler]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {icecekler.map((icecek) => (
                <div 
                  key={icecek.id} 
                  className="urun-kart-computer"
                  onClick={() => handleIcecekClick(icecek)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{icecek.name}</h3>
                    <div className="urun-fiyat-computer">{icecek.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={icecek.image} alt={icecek.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default SicakIcecekler;
